import React from "react";
import PdfDocumentTable from "../../../rightToInformation/components/RtiContent/PdfDocumentTable";
import mgtSevenFormPdf from "../../../../assets/tenders/resource/MGT-7-Form-2023-24pdf-cd55896a0f1be940d9d014141dc88535.pdf";

const mgtSevenDocuments = [
  {
    serial: 1,
    title: "Form MGT-7 Annual Return for year 2023-2024",
    fileName: "MGT-7-Form-2023-24pdf-cd55896a0f1be940d9d014141dc88535.pdf",
    href: mgtSevenFormPdf,
  },
];

const MgtSeven = () => (
  <section className="min-w-0 flex-1">
    <PdfDocumentTable
      documents={mgtSevenDocuments}
      minWidth="680px"
    />
  </section>
);

export default MgtSeven;
